import { getDateFnsLocale } from "@/lib/helpers";
import { isValid, format } from "date-fns";
import { useRouter } from "next/router";
import { useMemo } from "react";
import { Container } from "./styles";
import { useTranslation } from "@/lib/translations";

export type AsideProps = {
  releaseDate: string;
  category: string | null
};

const Aside: React.FC<AsideProps> = (props) => {
  const { releaseDate, category } = props;
  const { locale = "it" } = useRouter();
  const t = {
    articles: useTranslation("newsPage.articles", locale) || "",
  };

  const date = useMemo(() => {
    const d = new Date(releaseDate);
    if (isValid(d)) {
      return format(d, "PPP", { locale: getDateFnsLocale(locale) });
    } else {
      console.error("Invalid date:", releaseDate);
      return null;
    }
  }, [releaseDate, locale]);

  return (
    <Container>
      <span>{category || t.articles}</span>
      <time>{date}</time>
    </Container>
  );
};

export default Aside;
